<template>
  <div
    id="SurveyPictureModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first text-center">
                  <img
                    class="img-thumbnail mb-3"
                      style="height:auto; width:auto;"
                      v-bind:src="
                        '/Api/MasterFile/FromUrl?url=' +
                          encodeURIComponent(this.$route.params.url)
                      "
                  />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  async mounted() {
    let self = this;
    let router = this.$router;

    $("#PictureModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/PM/SurveyPictureModal.vue